import { render, staticRenderFns } from "./SampleBasisOfValidationDetailsForm.vue?vue&type=template&id=8270571c&"
import script from "./SampleBasisOfValidationDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./SampleBasisOfValidationDetailsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports